import * as tslib_1 from "tslib";
import { Setting } from '@app-state';
import { LICENSE_DEFINITIONS } from '@components/shared/license/license.constants';
import { globalStateFilter, } from '@models';
import { ODataGridComponent, urlStateHandler, } from '@pages/generics/grid';
import { FeatureflagsModalComponent } from '@pages/host/tenants/feature-flags/feature-flags.modal';
import { TenantLicenseModalComponent } from '@pages/host/tenants/license/tenant-license.modal';
import { TenantModalComponent } from '@pages/host/tenants/tenant.modal';
import { FeaturesService, ModalService, TenantService, } from '@services';
import cloneDeep from 'lodash-es/cloneDeep';
import { BehaviorSubject, merge, } from 'rxjs';
import { finalize, switchMap, tap, } from 'rxjs/operators';
var ɵ0 = urlStateHandler;
var TenantsPageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TenantsPageComponent, _super);
    function TenantsPageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.license$ = _this._appState.user.license.value$;
        _this.loading$ = new BehaviorSubject(false);
        _this.statusList = globalStateFilter();
        _this.licenseDefinitions = LICENSE_DEFINITIONS;
        _this.isMultipleDatabasesEnabled = !!_this._appState.settings.get(Setting.isMultipleDatabasesEnabled);
        _this._tenantService = _this._service;
        _this._modalService = _this._injector.get(ModalService);
        _this._featuresService = _this._injector.get(FeaturesService);
        return _this;
    }
    TenantsPageComponent.prototype.addTenant = function (tenant) {
        var _this = this;
        this._modalService
            .openModal(TenantModalComponent, cloneDeep(tenant))
            .afterClosedResult()
            .subscribe(function (res) {
            if (res.type === 1 /* Add */) {
                _this._refresh$.next();
            }
        });
    };
    TenantsPageComponent.prototype.allocateLicenses = function (tenant) {
        var _this = this;
        var modalRef = this._modalService
            .openModal(TenantLicenseModalComponent, cloneDeep(tenant), {
            data: {
                readonly: true,
                closeAfterAllocation: true,
            },
            size: 'sm',
            additionalClasses: ['allocate-license-modal'],
        });
        merge(modalRef.customEvent, modalRef.afterClosedResult())
            .subscribe(function (res) {
            if (res && res.type === 2 /* Update */) {
                _this._refresh$.next();
            }
        });
    };
    TenantsPageComponent.prototype.setActive = function (active, tenantId) {
        var _this = this;
        var tenantIds = tenantId ?
            [tenantId] :
            this._grid
                .selectionManager
                .selected
                .filter(function (e) { return e.isActive !== active; })
                .map(function (e) { return e.id; });
        if (tenantIds.length) {
            this._modalService.onConfirm(null, function () {
                _this.loading$.next(true);
                _this._tenantService.setActive(tenantIds, active)
                    .pipe(finalize(function () {
                    _this._refresh$.next();
                    _this.loading$.next(false);
                }))
                    .subscribe();
            }, function () { }, this._translate.instant(active ?
                'tenants_action_confirm_enable' :
                'tenants_action_confirm_disable'));
        }
    };
    Object.defineProperty(TenantsPageComponent.prototype, "isSomeTenantActive", {
        get: function () {
            return this._grid.selectionManager.selected.some(function (s) { return s.isActive; });
        },
        enumerable: true,
        configurable: true
    });
    TenantsPageComponent.prototype.manageFeatureFlags = function (tenantId) {
        var _this = this;
        var tenantIds = tenantId ?
            [tenantId] :
            this._grid
                .selectionManager
                .selected.map(function (e) { return e.id; });
        this.loading$.next(true);
        this._featuresService.getFeatureFlagsForTenants(tenantIds)
            .pipe(tap(function () { return _this.loading$.next(false); }), switchMap(function (featureDisplayInfo) {
            return _this._modalService.openModal(FeatureflagsModalComponent, {
                tenantIds: tenantIds,
                features: featureDisplayInfo,
            }).afterClosedResult();
        }), finalize(function () {
            _this.loading$.next(false);
        }))
            .subscribe(function (res) {
            if (res.type === 2 /* Update */) {
                _this._refresh$.next();
            }
        });
    };
    Object.defineProperty(TenantsPageComponent.prototype, "isSomeTenantDisabled", {
        get: function () {
            return this._grid.selectionManager.selected.some(function (s) { return !s.isActive; });
        },
        enumerable: true,
        configurable: true
    });
    return TenantsPageComponent;
}(ODataGridComponent));
export { TenantsPageComponent };
export { ɵ0 };
